import { initI18n } from '@wix/wix-i18n-config';
import { readFileSync } from 'fs';
const _joinPath = (baseDir, relativePath) => {
  const normalizedBase = baseDir.replace(/\/+$/, '');
  const normalizedRelative = relativePath.replace(/^\/+/, '');
  return `${normalizedBase}/${normalizedRelative}`;
};
export function readMessagesSafe(locale, fallbackLocale, baseDir) {
  if (fallbackLocale === void 0) {
    fallbackLocale = 'en';
  }
  if (baseDir === void 0) {
    baseDir = process.cwd();
  }
  try {
    const relativePath = `statics/assets/locales/messages_${locale}.json`;
    const filePath = _joinPath(baseDir, relativePath);
    return JSON.parse(readFileSync(filePath, 'utf8'));
  } catch {
    return readMessagesSafe(fallbackLocale, fallbackLocale, baseDir);
  }
}
export function getI18n(locale, remoteMessages, localMessages) {
  const isDev = process.env.NODE_ENV === 'development';
  const messages = isDev && localMessages ? localMessages : remoteMessages;
  return initI18n({
    messages,
    locale
  });
}
export const getBrowserLocale = function (regionOnly) {
  if (regionOnly === void 0) {
    regionOnly = false;
  }
  const locale = new Intl.DateTimeFormat().resolvedOptions().locale;
  if (regionOnly) {
    return locale.includes('-') ? locale.split('-')[1] : locale;
  }
  return locale;
};
//# sourceMappingURL=locale.js.map